import { render, staticRenderFns } from "./DetailsOptions.vue?vue&type=template&id=02237792&"
import script from "./DetailsOptions.vue?vue&type=script&lang=js&"
export * from "./DetailsOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports